import LoadingAnimation from "../LoadingAnimation";
import "./style.css";

function AppLoadingScreen() {
    return (
        <div id="app-loading-screen">
            <LoadingAnimation />
        </div>
    );
}

export default AppLoadingScreen;
